import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import { ArrowRightIcon } from "@heroicons/react/outline";
import React from "react";
import NextLink from "components/NextLink";

export default function NodePageTeaser({ node }) {
  const router = useRouter();
  const { t } = useTranslation("common");

  return (
    <div
      className="group relative h-full bg-primary text-white rounded-lg shadow-spread overflow-hidden cursor-pointer hover:bg-primary-dark transition-colors"
      onClick={() => router.push(node.path.alias)}
    >
      <div className="p-10">
        <div className="font-important text-xl mb-8">{node.title}</div>
        <NextLink
          href={node.path.alias}
          className="inline-block bg-white rounded-full p-2"
        >
          <ArrowRightIcon className="w-5 h-5 text-primary" />
          <span className="sr-only">{t("utils.more_link")}</span>
        </NextLink>
      </div>
    </div>
  );
}
